/**
    店铺首页
**/
<template>
  <!-- <div style="width: 1200px; margin: auto"> -->
  <div>
    <div class="navHeader">
        
        <div class="collectButoon navHeader_right"  style="width: 1200px; margin: auto">
            <div class="dashoardPage">
                <router-link to='/supplier'> <i class="el-icon-s-home blink"></i><i class="blink">批发市场首页</i></router-link>               
            </div>
            <div>
                <div class="inputSearchBox">
                  <el-input placeholder="请输入内容" v-model="inputSearch" class="input"  @keyup.enter.native="searchCommoditylist">
                    <el-button @click="searchCommoditylist" slot="append" icon="el-icon-search">搜本店</el-button>
                  </el-input>
                </div>
                <el-dropdown>
                    <span class="dt el-dropdown-link" style="cursor:pointer"><i class="el-icon-s-shop"></i> {{storeInfo.name}}</span>
                    <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item>
                        <shopStoreItem :shopInfo='storeInfo' :storeScore='storeScore' :isshow="0"></shopStoreItem>
                    </el-dropdown-item>
                    </el-dropdown-menu>
                </el-dropdown>        
                <el-button @click="getData($event)" ref="dataType" size="mini" icon="el-icon-chat-round" class="layui-btn site-demo-layim" data-type="chat">联系卖家</el-button>
                <!-- <el-button @click="addCollectionHandle(storeInfo.bxmId)" v-if="storeInfo.isCollect==0?true:false" size="mini" icon="el-icon-star-off">关注店铺</el-button>
                <el-button @click="removeCollectionHandle(storeInfo.bxmId)" v-if="storeInfo.isCollect==1?true:false" size="mini" icon="el-icon-star-on">已关注</el-button> -->
           </div>
        </div>
    </div>

    <div>
     <!-- 店铺分类 导航栏    -->
    <div class="categorysBox" style="background: #f42424;">
        <div  class="w" style="width: 1200px;">
        <div class="categorys">
            <div class="categorys-type">
                <a href="javascript:;" @click="dashboardClick"><i class="el-icon-s-shop"></i> 店铺首页</a>
            </div>
        </div>
        <div class="nav-main">
            <!-- <a href="" target="_blank"><i class="fa fa-bars"></i> 全部商品分类</a> -->
            <el-menu
            :default-active="activeIndex"
            class="el-menu-demo"
            mode="horizontal"
            router
            @select="handleSelect"
            >
            <!-- <el-menu-item
                @click="shopActivity"
            >
                <i>店铺活动</i>
            </el-menu-item> -->
            <el-menu-item
                v-for="(item, index) in navList"
                :key="index + '_nav'"
                @click="cateClick(item.sid)"
            >
             <el-dropdown trigger="click" @command="handleCommand">
                <span class="el-dropdown-link">
                  <i>{{ item.name }}</i><i v-if="secondNavList.length>0?true:false" class="el-icon-arrow-down el-icon--right"></i>
                </span>
                <el-dropdown-menu slot="dropdown" class="secondNavListCss">
                  <el-dropdown-item :command="item2.sid" v-for="(item2, index) in secondNavList" :key="index + '_nav2'">{{item2.name}}</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>   
            </el-menu-item>
            <!-- <el-menu-item
                v-for="(item, index) in navList"
                :key="index + '_nav'"
                @click="cateClick"
            >
                <i>{{ item.navTitle }}</i>
            </el-menu-item>             -->
            </el-menu>
        </div>
        </div>
    </div>
    <!-- 轮播图start -->
    <el-carousel trigger="click" height="500px" class="carouselBox" v-if="isCarousel&&swiperList.length>0?true:false" autoplay>
      <el-carousel-item v-for="(item) in swiperList" :key="item.id">
        <el-image
          :title="`${item.slideTitle}`"
          :src="`${item.slideLogo}`"
          fit="fill"
          style="width: 100%; height: 500px"
        >
          <div slot="error" class="image-slot">
            <i class="el-icon-picture-outline"></i>
          </div>
        </el-image>
      </el-carousel-item>
    </el-carousel>
    <!-- 轮播图end -->
    </div>

    <el-container class="filter_con" style="width: 1200px; margin: auto" >
      <el-container  style="margin-top:20px" v-if="!isShowActivity">
        <el-aside width="200px">
          <hotGoods :navTitle="hotGoodsTitle" :hotGoodsList='lefthotGoodsList' :supplieStore='1'></hotGoods>
        </el-aside>
        <el-main class="rightaside">
          <div class="orderby">
           <ul>
              <li :class="selectTag[0]" @click="getCommoditylist(formInline.cid, formInline.name||'','saleNum',0)">
                <a
                  data-pjax="#page-container"
                  href="javascript:;"
                  rel="nofollow"
                  >热销</a
                >
              </li>
              <li :class="selectTag[1]" @click="getCommoditylist(formInline.cid, formInline.name||'','price',1)">
                <a
                  data-pjax="#page-container"
                  href="javascript:;"
                  rel="nofollow"
                  >价格 <i v-show="priceSort" class="el-icon-arrow-up"></i> <i v-show="!priceSort" class="el-icon-arrow-down"></i>
                  </a>
              </li>
              <!-- <li :class="selectTag[2]" @click="getCommoditylist()">
                <a
                  data-pjax="#page-container"
                  href="javascript:;"
                  rel="nofollow"
                  >人气</a
                >
              </li> -->
              <li :class="selectTag[3]" @click="getCommoditylist(formInline.cid, formInline.name||'','createTime',3)">
                <a
                  data-pjax="#page-container"
                  href="javascript:;"
                  rel="nofollow"
                  >上新</a
                >
              </li>
              <!-- <li>
                <el-checkbox
                  v-model="checked1"
                  @change="showLowGoods"
                  label="仅显示特惠商品"
                ></el-checkbox>
              </li> -->
              <!-- <li>
                <el-checkbox
                  v-model="checked2"
                  @change="showHaveGoodList"
                  label="仅显示有货商品"
                ></el-checkbox>
              </li> -->
            </ul>
           
          </div>
          <el-row class="right_product" :gutter="20" v-loading="loading">
            <el-col v-for="(item,index) in rightGoodsList" :key="index" :span="6"
                ><div class="product_item selectItemCss_ls">
                  <div class="p-img">
                    <router-link
                      :to="`/goodsDetail_supplie?id=${item.id}`"
                      class="item_link"
                    >
                      <el-image
                        class="img-responsive"
                        :src="`${item.photos}`"
                        style="display: block"
                      ></el-image>
                    </router-link>
                  </div>
                  <div class="pro_name">
                    <router-link  :to="`/goodsDetail_supplie?id=${item.id}`">{{item.name}}</router-link>
                  </div>
                  <div class="pro_price_add">
                    <div class="now_price" v-if="item.notSale">
                      <i>¥</i>
                      <span>{{(item.price!=null && item.price!="")?item.price: item.marketprice}}</span>
                      </div>
                      <div v-else class="now_price">--</div>
                    <div class="cart add-to-cart" v-if="item.notSale">
                      <a
                        title="加入进货单"
                        href="javascript:;"
                        data-item_id="1207"
                        @click="item.type!=2?addCart(item.id,item.name,item.specificationlist,item.status,item.approvalStatus):$router.push(`/goodsDetail_supplie?id=${item.id}`)"
                        >{{item.type!=2?'加入进货单':'查看详情'}}</a
                      >
                    </div>
                    <div v-else class="cart add-to-cart" style="background:#999999;color:white;">未分销</div>
                  </div>
                </div>
            </el-col>
          </el-row>
		  <el-row>
		  	<!-- <div class="nodate" v-if="rightGoodsList.length==0?true:false"> -->
		  	<div class="nodate" v-if="rightGoodsList.length>0?false:true">
		  		<div class="first">对不起，对应商品分类或筛选组合下没有商品!</div>
		  	</div>
		  </el-row>
      <el-row>
        <el-col :span="24" class="pagination">
            <!-- 分页组件 -->
         <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>
        </el-col>
      </el-row>
        </el-main>
      </el-container>

    <!-- 店铺活动 开始 后续可提出作为公共部分-->
       <el-container style="margin-top:20px" v-if="isShowActivity">
           <el-row v-if="envelopeList.length>0?true:false" :gutter="20" style="width:100%" v-loading='activityLoading'>
                <el-col 
                    :xs="12"
                    :sm="6"
                    :md="6"
                    :lg="6"
                    v-for="(item,index) in envelopeList"
                    :key="index"
                    class="bigoutBox"
                >
                    <div class="wholeBox">
                        <img
                        v-if="item.icon!=''?true:false"
                        class="img-Activity"
                        :src="`${item.icon}`"
                        />
                        <div class="img-Activity" v-if="item.icon==''?true:false"><span class="noimg">暂无图片</span></div>
                        <div class="text_right" style="padding: 14px 0;">
                        <span style="
                            font-size: 30px;
                            color: #d93600;
                            height: 32px;
                            margin-top: 15px;
                            ">¥<em>{{item.bxyRedEnvelopesList[0].redenvelopesPrice}}</em></span>
                        <div style="color: #d93600;font-size: 14px">满{{item.bxyRedEnvelopesList[0].redenvelopesPrice}}元可用</div>
                        <el-button type="text" class="getNow" :disabled='item.flag'  @click="getRedEnveloped(item.bxyRedEnvelopesList[0].axyRid,item.bxyRedEnvelopesList[0].activityId)">立即领取</el-button>
                        </div>
                    </div>          
                </el-col>
            </el-row>
            <el-row style="width:100%" v-if="envelopeList.length==0?true:false">
                <div class="nodate" >
                    <div class="first">您还没有相关的优惠券</div>
                    <div class="second">店铺红包可享受商品优惠</div>
                </div>
            </el-row>
      </el-container>
       <!-- 店铺活动 结束 -->
    </el-container>

     <!-- 点击领取后的弹框 -->
    <el-dialog
        :visible.sync="dialogVisible"
        width="30%"
        center
        class="dialogBox">
        <div class="textCenter">领取成功，请在有效期前使用！</div>
        <span slot="footer" class="dialog-footer">
            <el-button type="primary" @click="dialogVisible = false" class="buttonBgd">确 定</el-button>
        </span>
    </el-dialog>

    <!-- 加入进货单弹框 -->
    <el-dialog
      class="addCartBox"
      :visible.sync="centerDialogVisible"
      width="30%"
      center
    >
      <div style="text-align: center" v-show="successInfo">
        <div class="addGoodsInfo">已成功加入进货单！</div>
        <div>{{ addGoodsName }}</div>
        <span slot="footer" class="dialog-footer">
          <el-button @click="centerDialogVisible = false">继续购物</el-button>
          <el-button type="primary" @click="$router.push('/shoppingcart')"
            >去进货单结算</el-button
          >
        </span>
      </div>
      <div style="text-align: center" v-show="!successInfo">
        <div>需要登录</div>
        <span slot="footer" class="dialog-footer">
          <el-button type="primary" @click="centerDialogVisible = false"
            >确定</el-button
          >
        </span>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import hotGoods from '@/components/hotGoods'
import shopStoreItem from '@/components/shopStoreItem'
import "@/assets/css/base.css";
import { score,imFriends,imUserID,commoditylistSupplie,addCollection,removeCollection,addShoppingCart ,storerList,redEnvelope,getredEnvelope,storeSwiperList,storeCategory } from "@/api/xunyou";
import Pagination from '@/components/Pagination'
import {mapState,mapMutations} from 'vuex'
export default {
    inject:['reload'],
  data() {
    return {
      inputSearch:'',//本店需要搜索的内容
        // 店铺分类导航栏
    activeIndex: "1",
    navList: [], // 店铺分类导航栏
      secondNavList:[],
    threeNavList:[],
    level:1, // 店铺分类级别
      isCarousel:true,
    //   店铺活动
    envelopeList:[],
    activityLoading:false,
    isShowActivity:false, // 店铺活动页面展示
    dialogVisible:false,

      userInfo: JSON.parse(localStorage.getItem("userdata")) || {},
      storeInfo:{},
      storeScore:{},
      loading:false,
      centerDialogVisible: false,
      successInfo: true,
      categorylists:'',
      addGoodsName: "",
      checked1: "",
	    checked2: "",
      rightGoodsList:[],
      hotGoodsTitle:'热卖商品',
      swiperList:[], // 轮播图
      lefthotGoodsList:[],
      imUserId:'',//店铺用户id
       // 查询条件是否选中
      selectTag: ["active","","","",""],
      priceSort: false,
      selectTagIdItem:0,
      // 请求数据参数
      formInline: {
        pageSize: 20,
        pageNum: 1,
        cid:'',
        stype:1    
      },
      // 分页参数
      pageparm:{
        pageSize:20,
        currentPage:1,
        total:0,
      },
    };
  },
  // 注册组件
  components: {hotGoods,Pagination,shopStoreItem},
  /**
   * 数据发生改变
   */

    // 路由离开的时候 // 离开此页面前修改展示导航栏，否则影响其他页面
    beforeRouteLeave(to, from, next) {
        this.$store.commit('getisShowNav',true); //
        next()
    },
  /**
   * 创建完毕
   */
 created() {
      // 此页面不展示导航栏
      this.$store.commit('getisShowNav',false) 
  },
  mounted(){
    // this.getCommoditylist()
    this.searchStorerList()
    this.getScore()
    this.searchRedEnvelope()
    //this.getSwiperList()
    this.getStoreCategoryList(this.level)
    this.getImUserID()
  },

  /**
   * 里面的方法只有被调用才会执行
   */
  methods: {
    // 搜索本店的商品
    searchCommoditylist() {
      commoditylistSupplie({
        mid: this.$route.query.storeId,
        stype:1,
        name:this.inputSearch||'',
        merchantName:this.userInfo.loginName
      })
        .then((res) => {
          this.loading = false;
          this.rightGoodsList = res.rows;
           // 分页赋值
          this.pageparm.currentPage = this.formInline.pageNum
          this.pageparm.pageSize = this.formInline.pageSize
          this.pageparm.total = res.total
         
        })
    },

      // 联系商家
     getData(e){
       if(this.userInfo.userId==undefined){
            this.$message.error("请登录！");
            setTimeout(()=>{
              this.$router.push('/login')
            },2000)
            return
          }
          this.addImFriends()
       layui.use('layim',(layim)=>{
            var layim = layui.layim;
            //面板外的操作
              //自定义会话
              layim.chat({
                name: this.storeInfo.name
                ,type: 'friend'
                ,avatar: this.storeInfo.logo || "static/layui/images/0.jpg"
                ,id: this.imUserId||''
              });
              // layer.msg('也就是说，此人可以不在好友面板里');
          })
    },

     addImFriends(){
        imFriends({
          uid:this.userInfo.imUserId,
          friendid:this.imUserId,
        })
          .then((res) => {
              if(res.code == 0){
                layui.use('layim',(layim)=>{
                  var layim = layui.layim;
                  layim.addList({
                      type: 'friend' //列表类型，只支持friend和group两种
                      ,avatar: this.storeInfo.logo || "static/layui/images/0.jpg" //好友头像
                      ,username: this.storeInfo.name //好友昵称
                      ,groupid: 5 //所在的分组id
                      ,id: this.imUserId //好友id
                      ,sign: "签名" //好友签名
                  });
                })
              }
          })
    },

       //   店铺分类模块
     handleSelect(key, keyPath) {
      if(this.$route.path==key){
         this.reload()
      }
    },

    // 查询店铺分类
    getStoreCategoryList(level,id){
        storeCategory({
          level:level, // 代表分类几级
          mid:this.$route.query.storeId,
        })
          .then((res) => {
              this.loading = false;   
              if(level==1){
                this.navList = res.rows
              } else if (level==2){
                this.secondNavList = res.rows
              }else{
                this.threeNavList = res.rows
              }   
              this.getCommoditylist(id,this.formInline.name,this.formInline.sortname,this.selectTagIdItem)
          })
          .catch((err) => {
            this.loading = false;
            this.$message.error("店铺商品分类失败，请稍后再试！");
          });
    },

    // 点击店铺首页
    dashboardClick(){
        this. isCarousel=true
        this.isShowActivity = false
        this.searchStorerList()
        this.getScore()
        this.searchRedEnvelope()
        this.getSwiperList()
        this.getStoreCategoryList(this.level)
        this.getImUserID()
    },

    // 点击一级分类
    cateClick(id){
      this.formInline.cid = id
      this.formInline.pageNum = 1
        this.isCarousel = false
        this.isShowActivity = false
         this.getStoreCategoryList(2,id)
    },

    // 点击二级分类
     handleCommand(command) {
        this.getCommoditylist(command)
      },

    // ----------------------- 轮播图 开始 --------------------------------
      getSwiperList(){
        var store={};
         store.slideTitle='店铺横幅';
         store.slideLogo=this.storeInfo.banner_pc;
        if(store.slideLogo!=null&&store.slideLogo!='null'&&store.slideLogo!='')
        {
           this.swiperList.push(store);
        }
        // storeSwiperList({
        //   type:1, // 1：pc;2:wap
        //   storeId:this.$route.query.storeId,
        // })
        //   .then((res) => {
        //       this.loading = false;        
        //       this.swiperList = res.rows
        //   })
        //   .catch((err) => {
        //     this.editFormVisible = false;
        //     this.loading = false;
        //     this.$message.error("店铺查询失败，请稍后再试！");
        //   });
      },
    // ----------------------- 轮播图 结束 --------------------------------

     // 店铺查询
    searchStorerList() {
      this.loading = true;
      storerList({
        userId:this.userInfo.userId||'',
        bxmId:this.$route.query.storeId,
      })
        .then((res) => {
            this.loading = false;
            this.storeInfo = res.rows[0];
            this.getSwiperList();   
        })
        .catch((err) => {
          this.editFormVisible = false;
          this.loading = false;
          this.$message.error("店铺查询失败，请稍后再试！");
        });
    },

    // 获取店铺评价 
    getScore() {
       score({
        type: 1,
        bxmId:this.$route.query.storeId,
      })
        .then((res) => {
          if(res.code == 0){
            this.storeScore = res.data;
          }else{
             this.$message.error(res.msg);
          } 
        })
        .catch((err) => {
          this.$message.error(res.msg);
        });
    },

    // 查询店铺的用户管理
      getImUserID() {
        imUserID({
          bxmid:this.$route.query.storeId,
        })
          .then((res) => {
              this.imUserId = res.data.imUserId;
          })
          .catch((err) => {
            this.$message.error("查询店铺用户失败，请稍后再试！");
          });
      },

    // 添加关注
    addCollectionHandle(id) {
      if(this.userInfo.userId==undefined){
            this.$message.error("请登录！");
            setTimeout(()=>{
              this.$router.push('/login')
            },2000)
            return
          }
      // this.loading = true;
      const req ={
        type:2, //1:商品；2：店铺；必填
        uid:this.userInfo.userId,
        cid:id, // 店铺id
      }
      addCollection(req)
        .then((res) => {
          if(res.code == 0){
            this.searchStorerList()
          }
        })
        .catch((err) => {
          this.$message.error("关注失败，请稍后再试！");
        });
    },
    // 取消关注
    removeCollectionHandle(id) {
      // this.loading = true;
      const req ={
        type:2, //1:商品；2：店铺；必填
        uid:this.userInfo.userId,
        cid:id, // 店铺id
      }
      removeCollection(req)
        .then((res) => {
          if(res.code == 0){
            this.searchStorerList()
          }
        })
        .catch((err) => {
          this.$message.error("关注失败，请稍后再试！");
        });
    },
    // 分页插件事件
    callFather(parm) {
      this.formInline.pageNum = parm.currentPage
      this.formInline.pageSize = parm.pageSize
      this.getCommoditylist(this.formInline.cid)
    },
     // 商品列表查询
    getCommoditylist(id,adWord,sortname,selectTagId) {
       this.selectTagIdItem = selectTagId
       this.formInline.name = adWord
       this.formInline.sortname = sortname
       this.formInline.cid = id
      this.loading = true;

      let sortway = false;
      if(selectTagId == 1 &&  this.selectTag[selectTagId] === 'active' ){
        this.priceSort = !this.priceSort
        sortway = this.priceSort
      }
      if(selectTagId == null) {
        this.selectTag[0] = "active" //  更改检索条件样式
      } else{
        this.selectTag = [] 
        this.selectTag[selectTagId] = "active" //  更改检索条件样式
      }

      commoditylistSupplie({
        sid:id||'',
        mid: this.$route.query.storeId,
        stype:1,
        name:adWord||'',
        sortname: sortname,
        sortway: sortway,
        pageSize:this.formInline.pageSize,
        pageNum:this.formInline.pageNum,
        merchantName:this.userInfo.loginName
        // bxmId:this.$route.query.storeId
        // type:2
      })
        .then((res) => {
          //   if (res.code == 0) {
          this.loading = false;
          this.rightGoodsList = res.rows;
          console.log(this.rightGoodsList,'this.rightGoodsList')
          this.lefthotGoodsList = res.rows>4? res.rows.slice(0,4):res.rows
          // this.childMsgs.total = res.total
           // 分页赋值
          this.pageparm.currentPage = this.formInline.pageNum
          this.pageparm.pageSize = this.formInline.pageSize
          this.pageparm.total = res.total
         
        })
        .catch((err) => {
          this.loading = false;
          this.$message.error("查询商品列表失败，请稍后再试！");
        });
    },
    // 加入进货单
    addCart(id,name,specificationlist,status,approvalStatus) {
      if(this.userInfo.userId==undefined){
            this.$message.error("请登录！");
            setTimeout(()=>{
              this.$router.push('/login')
            },2000)
            return
          }
      if(status==1&&approvalStatus==1){
         addShoppingCart({
        cid: id,
        uid: this.userInfo.userId,
        number: 1,
        bxysid:0
        // bxysid:specificationlist.length>0?specificationlist[0].bXySid:''
      })
        .then((res) => {
            if (res.code == 0) {            
              console.log("res", res);
              this.addGoodsName = name;
              this.centerDialogVisible = true;
          
            }
        })
        .catch((err) => {
          this.loading = false;
          this.$message.error("添加进货单失败，请稍后再试！");
        });
      }else{
        this.$message.error('暂时缺货')
				return
      }     
    },

     // ------------------------------店铺活动 开始-----------------------------------
    shopActivity(){
        this.isShowActivity = true
        this.isCarousel =false
    },
     // 活动查询
      searchRedEnvelope() {
          this.loading = true
         redEnvelope({
           uid:this.userInfo.userId || '',
         })
            .then(res => {
              if (res.code == 0) {
                  this.loading = false
                  this.envelopeList = res.rows;
                  this.envelopeList.forEach((item)=>{
                      item.isGet = false
                  })
              } else {
                this.$message({
                  type: 'info',
                  message: res.msg
                })
              }
            })
            .catch(err => {
              this.editFormVisible = false
              this.loading = false
              this.$message.error('查询红包失败，请稍后再试！')
            })
    },
     // 立即领取红包
      getRedEnveloped(aXyRid,activityId){
        if(this.userInfo.userId==undefined){
            this.$message.error("请登录！");
            setTimeout(()=>{
              this.$router.push('/login')
            },2000)
            return
          }
          getredEnvelope({aXyRid:aXyRid,muid:this.userInfo.userId,activityId: activityId })
            .then(res => {
              if (res.code == 0) {
                this.dialogVisible= true
                this.searchRedEnvelope()
              } else {
                this.$message({
                  type: 'info',
                  message: res.msg
                })
              }
            })
            .catch(err => {
              this.editFormVisible = false
              this.loading = false
              this.$message.error('查询红包失败，请稍后再试！')
            }) 
            // this.envelopeList.forEach((item)=>{
            //     if(item.bxyRedEnvelopesList[0].aXyRid == aXyRid&&item.isGet!=true){
            //         item.isGet = true
            //         this.dialogVisible= true
            //     }else{
            //         this.$message.info('您的单张券已领取达到上限.')
            //     }                
            // })          
      },

    //------------------------------店铺活动 开始-----------------------------------
  },
};
</script>

<style scoped lang='less'>
.inputSearchBox {
    display: inline-block;
    height: 30px;
    margin-top: 8px;
    margin-right: 20px;
    /deep/.el-input__inner{
      height: 30px;
      line-height: 30px;
    }
    span{
      font-size: 12px;
    }
}
.secondNavListCss .el-dropdown-menu__item:focus, .secondNavListCss .el-dropdown-menu__item:not(.is-disabled):hover {
      background-color: #f4242426 !important;
      color: #f42424 !important;
  }
.navHeader {
    display: flex;
    justify-content: flex-end;
    line-height: 30px;
    background: #eaeaea;
    .navHeader_right{
        .dashoardPage{
            font-size: 15px;
            color: #999;
            margin-left: 50px;
            cursor: pointer;
            margin-top: 10px;
            i.el-icon-s-home {
                font-size: 20px;
                vertical-align: revert;
                color: #d40000;
                margin-right: 5px;
            }            
        }
        button.el-button.el-button--default.el-button--mini {
            background: transparent;
            border: none;
            padding: 0;
            font-size: 14px;
            margin-right: 20px;
        }
    }
    .collectButoon {
        display: flex;
        width: 1200px;
        margin: auto;
        justify-content: space-between;
        i.el-icon-s-shop {
            font-size: 20px;
            vertical-align: middle;
            color: #d40000;
        }
         /deep/i.el-icon-star-on {
           font-size: 20px;
            color: #f12b2d;
            vertical-align: middle;
          }
          /deep/i.el-icon-star-off{
                font-size: 20px;
                vertical-align: middle;
          }
    }
    .el-dropdown {
        margin-right: 20px;
    }
}
.carouselBox{
    // width: 1600px;
    margin: auto;
    margin-bottom: 20px;
}

.labelTitle {
  text-align: left;
  padding-left: 15px;
  font-weight: bold;
  color: #666;
  font-size: 14px;
}
.labelcontent {
}
.fisrtNav {
  padding: 10px 0px;
  border-top: 1px dashed #ddd;
  border-bottom: 1px dashed #ddd;
  margin-bottom: 20px;
}
.leftaside {
  /* background: pink; */
  /* padding: 10px; */
  box-sizing: border-box;
  font-size: 14px;
  border: 1px solid #ddd;
  margin-right: 10px;
}
.leftaside h4 {
  padding: 10px;
  border-bottom: 1px solid #ddd;
}
.left_product {
  padding: 10px;
}
.left_product li {
  margin-bottom: 30px;
}
.pro-price {
  margin: 10px 0;
  color: #e4393c;
}
.pro_name {
  text-overflow: -o-ellipsis-lastline;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  line-clamp: 2;
  -webkit-box-orient: vertical;
  font-size: 14px;
  margin: 10px 0;
  height: 40px;
}
.img-responsive {
  /* width: 100%; */
  width: 200px;
  height: 200px;
}
.rightaside {
  /* background: yellow; */
  padding: 0px;
  box-sizing: border-box;
  overflow: hidden;
}
.el-header {
  height: auto !important;
}

/* 右边 */
.orderby {
  width: 100%;
  padding: 8px 0;
  background: #f1f1f1;
}
.orderby ul {
  width: 100%;
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
}
.orderby ul li {
  background: #fff;
  color: #333;
  margin-left: 10px;
  border: 1px solid #ddd;
  font-size: 12px;
  padding: 2px 15px;
  line-height: 20px;
}
.active {
  background: #ba3232 !important;
  font-weight: bold;
}
.active a {
  color: white !important;
}
.orderby .el-checkbox__label {
  font-size: 12px !important;
}
.orderby .el-checkbox__input {
  vertical-align: bottom !important;
}
.right_product {
  padding: 20px;
}
.right_product .product_item {
  margin-bottom: 20px;
  border: 1px solid #fff;
  border-color: #e9e9e9;
  -webkit-box-shadow: 0 0 2px 2px #f8f8f8;
  box-shadow: 0 0 2px 2px #f8f8f8;
  padding: 10px;
  box-sizing: border-box;
}
.product_item:hover img {
  opacity: 0.7;
}
.pro_price_add {
  display: flex;
  justify-content: space-around;
}
.cart.add-to-cart,
div.now_price {
  flex: 1;
  font-weight: bold;
  border: 1px solid #f12b2d;
  padding: 8px 0;
  text-align: center;
}
/* .cart.add-to-cart:hover{
	border: 1px solid #f12b2d;
} */
div.now_price {
  color: white;
  background: #f12b2d;
  border: 1px solid #f12b2d;
}
.dialog-footer {
  margin-top: 20px;
  display: block;
}
.addGoodsInfo {
  font-size: 24px;
}
.addCartBox .el-button--primary {
  color: #fff;
  background-color: #ff6700;
  border-color: #e65d00;
}

.more_filter {
  width: 100%;
  text-align: center;
  border-top: 1px dashed #ddd;
  margin-top: -1px;
}
.more_filter:hover {
  border-color: #e13c41;
}
.more_filter span {
  display: inline-block;
  height: 30px;
  line-height: 26px;
  margin-top: -1px;
  width: 130px;
  text-align: center;
  border-width: 1px;
  border-style: dashed;
  border-color: #fff #ddd #ddd;
  background: #fff;
  font-size: 12px;
  color: #939393;
  cursor: pointer;
}
.filter_con .more_filter span i {
  font-size: 12px;
}
.filter_con .more_filter:hover span {
  color: #e13c41;
  border-color: #fff #e13c41 #e13c41;
}
.nodate{
    text-align: center;
    margin-top: 20%;
    font-size: 16px;
}
.nodate .first {
	margin: 40upx 0 12upx;
	font-size: 28upx;
}

/* top菜单 */
.categorys {
  float: left;
  width: 170px;
  height: 30px;
  position: relative;
}

.categorys-type {
  background-color: #f42424;
  // text-align: center;
  margin-left: 50px;
  font-size: 0;
  line-height: 30px;
}
.categorys-type:hover {
    background: white;
    a{
        color: #f42424 !important;
    }
}

.categorys-type a {
  font-size: 14px;
  font-weight: 700;
  color: #fff;
  display: block;
  i.el-icon-s-shop{
    font-size: 20px;
    vertical-align: middle;
  }
}

.nav-main {
  float: left;
  width: 968px;
  overflow: hidden;
  height: 30px;
  line-height: 30px;
}
.el-menu{
    background-color: #f42424;
}
.el-menu--horizontal > .el-menu-item {
  float: left;
  height: 30px;
  line-height: 30px;
  margin: 0;
  border-bottom: 2px solid transparent;
  color: white;
    i {
        color: #ffffff;
    }
}
.el-menu--horizontal > .el-menu-item:hover{
    i {
        color: #f42424 !important;
    }
}
.el-menu-item:focus{
    i {
        color: #f42424 !important;
    }
}

.categorysBox{
    /* 分类表 */
    .categorys-tab-content {
    height: auto !important;
    padding: 15px 0;
        z-index: 30;
        background-color: #000;
        background-color: rgba(0, 0, 0, 0.6);
        /* bingo */
    display:block;
    position: relative;
    }

    .categorys-tab-content .categorys-items {
        position: relative;
        height: 100%;
    }

    .categorys-tab-content .categorys-item {
        cursor: pointer;
        height: 14.29%;
    }

    .categorys-tab-content .item-content {
        padding: 5px 16px;
        float: left;
        width: 200px;
    }

    .categorys-tab-content .item-content .icon-other {
        float: left;
        width: 18px;
        height: 18px;
    }

    .categorys-tab-content .item-content .icon-other img {
        width: 100%;
    }

    .categorys-tab-content .selected .item-content {
        background-color: rgba(0, 0, 0, 1);
    }

    .categorys-tab-content .iconfont {
        float: left;
        color: #bfbfbf;
    }

    .categorys-tab-content .categorys-title {
        float: left;
    margin-left: 10px;
        text-align: left;
    }

    .categorys-tab-content .categorys-title strong {
        display: block;
        font-weight: normal;
    }

    .categorys-tab-content .categorys-title strong a {
        color: #fff;
        font-size: 14px;
    }

    .categorys-tab-content .categorys-title span {
        display: block;
        font-size: 0;
    }

    .categorys-tab-content .categorys-title span a {
        color: #bfbfbf;
        margin-right: 10px;
        font-size: 14px;
    }

    .categorys-tab-content .categorys-title span a:hover,
    .categorys-tab-content .categorys-title strong a:hover {
        color: #e23435;
    }

    .categorys-items-layer {
        display: none;
        position: absolute;
        top: 0;
        left: 232px;
        width: 966px;
        min-height: 498px;
        border: 1px solid #fff;
        background-color: #fff;
        box-shadow: 0px 0px 3px 2px rgba(0, 0, 0, .1);
        -webkit-transition: top .25s ease;
    transition: top .25s ease;
    .nodataCss {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        font-size: 14px;
    }
    }
}

// 店铺活动
.bigoutBox{
    .wholeBox {
        display: flex;
        justify-content: flex-start;
        width: 280px;
        height: 126px;
        border: 1px solid #eaeaea;
        padding-right: 10px;
        margin-bottom: 20px;
        box-sizing: border-box;
        .el-button--text.is-disabled {
            color: #e4e7ed;
            background-color: #999;
        }
        }
        .img-Activity {
        width: 45%;
        padding: 10px;
        text-align: center;
            line-height: 100px;
        }
        .getNow {
        /* width: 132px;
        height: 40px; */
        margin-top: 1px;
        background-color: #d93600;
        padding: 7px 15px;
        font-size: 15px;
        color: white;
        }
        
        
        .first {
            margin: 40upx 0 12upx;
            font-size: 28upx;
        }

        .second {
            font-size: 24upx;
            color: #999;
        }
        .nodate{
            text-align: center;
            margin-top: 10%;
            margin-bottom: 10%;
            font-size: 16px;
        }
        span.noimg {
            display: inline-block;
            width: 100%;
            background: #ccc;
        }
}

button.el-button.buttonBgd.el-button--primary {
    color: #fff;
    background-color: #d93600;
    border-color: #d93600;
    width: 180px;
    margin-left: 12px;
    margin-top: 5px;
    font-size: 14px;
}
.dialogBox .textCenter {
    text-align: center !important;
    font-size: 24px !important;
}

.pagination{
  text-align: right;
  /deep/.el-pagination.is-background .el-pager li:not(.disabled).active {
      background-color: #ff6700;
      color: #FFF;
      width: 20px;
  }
  /deep/.el-pagination.is-background .btn-next, /deep/.el-pagination.is-background .btn-prev, /deep/.el-pagination.is-background .el-pager li {
    width: 20px;
  }
  /deep/input[disabled], input[disabled="disabled"], input[readonly], input[readonly="readonly"] {
      background-color: transparent;
  }
}
</style>

 
 

 


// WEBPACK FOOTER //
// src/views_supplier/store/storeHome.vue